var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOminz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_754",
    "data-name": "Group 754",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M32,0A32,32,0,1,1,0,32,32,32,0,0,1,32,0Z",
    fill: "#24397a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "category-24px",
    transform: "translate(15.694 15.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M13.125,20.621a6.168,6.168,0,1,1,6.168,6.168A6.166,6.166,0,0,1,13.125,20.621ZM0,26V15.33H10.666V26ZM4.668,12,12,0l7.332,12Z",
    transform: "translate(3.998 2.668)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M0,0H32V32H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "category-24px-2",
    "data-name": "category-24px",
    transform: "translate(15.694 15.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4-2",
    "data-name": "Union 4",
    d: "M13.125,20.621a6.168,6.168,0,1,1,6.168,6.168A6.166,6.166,0,0,1,13.125,20.621ZM0,26V15.33H10.666V26ZM4.668,12,12,0l7.332,12Z",
    transform: "translate(3.998 2.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M0,0H32V32H0Z",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOminz);
export default __webpack_public_path__ + "static/media/ominz.cce0dc51be1a14dd4ea28a9483ecd827.svg";
export { ForwardRef as ReactComponent };